module.exports = __webpack_public_path__ + "static/Award1-3870a44ed25f7548b972e2c9428b79f0.png";